import Linkify from 'linkify-react';
import * as React from 'react';
import styled from 'styled-components';

import ProfileImg from '../../shared/components/ProfileImg';
import t from '../../shared/translations';
import Box from './Box';
import { IPerson } from './OutsideFeedback';

interface IProps {
    person: IPerson;
    description: string;
}

const ProfileBox = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: space-between;

    > *:first-child {
        flex-grow: 1;
        font-size: 1.25rem;
        @media (min-width: 600px) {
            font-size: 1.5rem;
        }
    }
    > *:last-child {
        flex-shrink: 0;
    }
`;

function Info({ person, description }: IProps): JSX.Element {
    const name = `${person.firstName} ${person.lastName}`;
    return <>
        <ProfileBox>
            <div>{t('public.outside-feedback.info-sender-name', { name })}</div>
            <div><ProfileImg src={person.profilePicSrc} /></div>
        </ProfileBox>
        <Box>
            <Linkify options={{ nl2br: true }} tagName='p'>{description}</Linkify>
        </Box>
    </>;
}

export default Info;
